export default {
  checkoutSessionLoading: false,
  checkoutSessionId: false,
};
